import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import loadable from "@loadable/component";
import customTheme from "@themes/project.json";
import createTheme from "@material-ui/core/styles/createTheme";
import ThemeProvider from "@material-ui/styles/ThemeProvider";

import "@css/index.css";
import { useEffect } from "react";

const Core = loadable(() => import("@core"));
const Dashboard = loadable(() => import("./components/Dashboard"));
const DashboardHeadline = loadable(() => import("./components/DashboardHeadline"));
const CompanyDetect = loadable(() => import("./components/CompanyDetect"));
const JobListDetect = loadable(() => import("./components/JobListDetect"));
const Shop = loadable(() => import("./components/Shop"));

const theme = createTheme(customTheme);

const App = () => {
	useEffect(() => {
		document.body.addEventListener("mco-connect-logout", () => {
			sessionStorage.removeItem("mco-shop-logged-in");
		});
	}, []);

	return (
		<ThemeProvider theme={theme}>
			<Suspense fallback={<></>}>
				<Core
					additionalContentElements={[
						{
							component: <Dashboard />,
							tag: "extension-dashboard"
						},
						{
							component: <DashboardHeadline />,
							tag: "extension-dashboard-headline"
						},
						{
							component: <CompanyDetect />,
							tag: "extension-company"
						},
						{
							component: <JobListDetect />,
							tag: "extension-jobs"
						}
					]}
					additionalRoutes={[
						{
							path: "/:lang/shop/*",
							element: <Shop />
						}
					]}
				/>
			</Suspense>
		</ThemeProvider>
	);
};

ReactDOM.render(<App />, document.getElementById("root"));
